import { createSlice } from '@reduxjs/toolkit'
import { createCompanyPositions, deleteCompanyPositions, getCompanyPositions, updateCompanyPositions } from './thunks'

const initialState = {
    list: [],
    loading: false,
    error: null
}

export const companyPositionsSlice = createSlice({
  initialState,
  name: 'companyPositions',
  reducers: {
    setInitialData: (state) => {
      state.data = []
    }
  },
  extraReducers: builder =>
  builder
  .addCase(getCompanyPositions.fulfilled, (state, action) => {
    console.log("action.payload: ", action.payload)
    state.list = action.payload
    state.isPending = false
  })
  .addCase(createCompanyPositions.fulfilled, (state, action) => {
    state.list.push(action.payload)
    state.isPending = false
  })
  .addCase(updateCompanyPositions.fulfilled, (state, action) => {
    const index = state.list.findIndex((society) => society.id === action.payload.id);
    if (index !== -1) {
      state.list[index] = action.payload;
    }
  })
  .addCase(deleteCompanyPositions.fulfilled, (state, action) => {
    state.loading = false;
    state.list = state.list.filter((society) => society.id !== action.payload);
  })
})

export const { setInitialData, setOpenModal } = companyPositionsSlice.actions

export default companyPositionsSlice.reducer